<template>
  <div :id="id">
    <div :class="[{'hm-floating-button__action--disabled': disabled === true || processing === true}]" class="hm-floating-button__action js-transition--stagger" @click="throttledOnClick($event)">
      <div class="hm-floating-button__action__label">
        <span>{{ label }}</span>
      </div>
      <div :class="[`hm-floating-button__action__button--${color}`]" class="hm-floating-button__action__button">
        <icon :icon="disabled === true ? 'close' : icon" />
      </div>
    </div>
  </div>
</template>

<script>

import { isEmpty, isNil, sampleSize, throttle, trim } from 'lodash';
import { TweenMax, TimelineMax } from 'gsap';
import TimerMixin from '../../../mixins/TimerMixin';
import HmFloatingButtonMixin from '../../../mixins/HmFloatingButtonMixin';

export default {
  name: 'HmFloatingChildButton',

  mixins: [TimerMixin, HmFloatingButtonMixin],

  props: {
    name: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    throttle: {
      type: Number,
      default: 1000,
    },
  },

  data: function () {
    return {
      processing: false,
      processingTimer: null,
      throttledOnClick: throttle(this.onClick, this.throttle, { leading: true, trailing: false }),
    };
  },

  computed: {
    saveInProgress: function () {
      return this.$store.getters['save/saveInProgress'];
    },
    id: function () {
      const id = this.$attrs.id || this.name || sampleSize('abcdefghijklmnopqrstuvwxyz', 8).join('');
      return isEmpty(this._parentHtmlId) ? id : `${this._parentHtmlId}-${id}`;
    },
  },

  methods: {
    addUIBreadcrumb: function (action, metadata = {}) {
      try {
        this.$rollbar.captureEvent('manual', {
          category: 'UI',
          action: action || '-',
          metadata: {
            ...metadata,
            url: window.location.href,
            hotel: this.$root.hotel,
            user: this.$root.username,
            subdomain: this.$store.getters['hotel/hotelSettings'].hotel.tenant.subdomain,
          },
        }, 'info');
        // eslint-disable-next-line no-empty
      } catch (ignore) { }
    },
    onClick: function ($event) {
      if (this.disabled) return;

      const el = this.$el.querySelector('.hm-floating-button__action__button');

      const tl = new TimelineMax({});
      tl.add(TweenMax.fromTo(
        el,
        0.25,
        {
          boxShadow: '0px 6px 15px 0px rgba(0,39,46,0.55)',
        },
        {
          boxShadow: 'inset rgba(0, 39, 46, 0.55) 0px 0px 15px -2px',
        },
      ));

      tl.add(TweenMax.fromTo(
        el,
        0.25,
        {
          boxShadow: 'inset rgba(0, 39, 46, 0.55) 0px 0px 15px -2px',
        },
        {
          boxShadow: '0px 6px 15px 0px rgba(0,39,46,0.55)',
        },
      ));

      if (!this.processing) {
        this.processing = true;
        this.processingTimer = this.setTimeout(() => {
          this.processing = false;
        }, this.throttle);

        this.$serviceBus.$emit('autosave');
        this.$nextTick(() => {
          this._onClick($event);
        });
      }
    },
    _onClick: function ($event) {
      if (this.saveInProgress) {
        this.setTimeout(() => { this._onClick($event); }, 500);
        this.clearInterval(this.processingTimer);
        this.processingTimer = this.setTimeout(() => {
          this.processing = false;
        }, this.throttle);
      } else {
        this.setTimeout(() => {
          this.$emit('click', $event);
          // direct parent is the transition
          this.$parent.$parent.$emit('childClicked', $event);
          this.addUIBreadcrumb(
            'User clicked floating child button',
            {
              id: this.id,
              name: this.label,
            },
          );
        }, 400);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmFloatingChildButton.vue